export default __webpack_public_path__ + "0507fa51d77beea62bbe13bbdb532d1d.png";